import { render, staticRenderFns } from "./CbsReadiness.vue?vue&type=template&id=64874743"
import script from "./CbsReadiness.vue?vue&type=script&lang=js"
export * from "./CbsReadiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports